import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import OtpSection from "./OtpSection";
import LiquidationSucess from "./LiquidationSucess";
import { useLocation } from 'react-router-dom'
import LiquidationMldFirst from "./LiquidationMldFirst";
import { getAcceptRedeemQuote, getQuoteRequest, getRedeemOrderDetails, getRedeemptionAmount } from "../services/waitlist-service";
import { toast } from "react-toastify";
import Loader from "react-loaders";

export default function LiquidationMldMain(props) {
    const location = useLocation();
    const [marksView, setMarksView] = useState([true, false, false, false, false, false]);
    const [marksDone, setMarksDone] = useState(new Array(3).fill(false));
    const [showSecond, setShowSecond] = useState(false);
    const [showFinal, setShowFinal] = useState(false)
    const [showForth, setShowForth] = useState(false)
    const [showSucess, setShowSucess] = useState(false)
    const [units, setUnits] = useState(1);
    const [otp, setOtp] = useState("");
    const [orderId, setOrderId] = useState('');
    const [liquidationDetails, setLiquidationDetails] = useState();
    const [liquidationRedeem, setLiquidationRedeem] = useState(null);
    const [loader, setLoader] = useState(true);



    const increaseUnits = () => {
        if (units < props.liquidationDetails.availableUnits) {
            setUnits((units) => Number(units) + 1)
        } else {
            return toast.error("You don’t have sufficient units")
        }
    };

    const decreaseUnits = () => {
        if (units > 1) {
            setUnits((units) => Number(units) - 1);
        }
    };

    const setUnitsFunc = (val) => {
        const result = val.replace(/[^0-9]/g, "");
        if (result <= props?.liquidationDetails?.availableUnits) {
            setUnits(Number(result));
        } else {
            return toast.error("You don’t have sufficient units")
        }
    };

    function verifyOtp() {
        if (showForth) {
            getAcceptRedeemQuote(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, liquidationRedeem[0].orderId, otp).then(
                (res) => {
                    if (res.success) {
                        setShowSecond(false)
                        setShowForth(false)
                        setShowSucess(true)
                        let mark = [...marksView]
                        mark[4] = true
                        setMarksView(mark)
                    } if (!res.success) {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error("OTP invalid", err);
                }
            );

        } else {
            getQuoteRequest(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, units, otp).then(
                (res) => {
                    if (res.success) {
                        setShowSecond(false)
                        setShowFinal(true)
                    } if (!res.success) {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error("OTP invalid", err);
                }
            );
        }
    }

    function updateOtp(val) {
        setOtp(val);
    }

    function resendOtp() {
        getQuoteRequest(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, props.units, 0).then(
            (res) => {
                if (res) {
                    toast.success("OTP sent sucessfully")
                }
            },
            (err) => {
                toast.error("Error calling the API:", err);
            }
        );
    }


    useEffect(() => {
        if (showFinal) {
            let mark = [...marksView]
            mark[2] = true
            setMarksView(mark)
        }
    }, [showFinal])

    // useEffect(() => {
    //     if (showForth) {
    //         let mark = [...marksView]
    //         mark[4] = true
    //         setMarksView(mark)
    //     }
    // }, [showForth])

    useEffect(() => {
        if (showSecond) {
            let mark = [...marksView]
            mark[1] = true
            setMarksView(mark)
        }
    }, [showSecond])


    useEffect(() => {
        if (orderId && props.bondDetails) {
            let mark = [...marksView]
            mark[2] = true
            mark[1] = true
            mark[3] = true
            setMarksView(mark)
            getRedeemOrderDetails(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, orderId).then(
                (res) => {
                    if (res.success) {
                        setLiquidationRedeem(res.data)
                    } if (!res.success) {
                        toast.error("Something went wrong");
                    }
                },
                (err) => {
                    toast.error("Something went wrong", err);
                }
            );
        }
    }, [orderId, props.bondDetails])

    useEffect(() => {
        let path = location.pathname.split('redeem/')
        if (path[1]) {
            setOrderId(path[1])
        }
    }, [])

    useEffect(() => {
        let path = location.pathname.split('redeem/')
        if (path[1]) {
            setOrderId(path[1])
        }
    }, [])

    return (
        <>
            {!props.loader ? <div className="liquidation-dashboard">
                <div className="payment-modal-body">
                    <div className="navi-logo-div">
                        {/* <img src={process.env.REACT_APP_IMAGES_PATH + "incred_logo.webp"} alt='incred-money-logo'/>
                        <div className="divider" /> */}
                        <img className="second-img" src={props?.bondDetails?.logoUrl} alt="url"/>
                    </div>
                    <div className="mark-main-2">
                        <div className="marks">
                            <img src={process.env.REACT_APP_IMAGES_PATH + "progress1.webp"} alt="progress-1"/>
                            {marksView[0] && <div className="mdi-holder"></div>}
                            {marksDone[0] && <div className="mdi-holder"></div>}
                            {!marksView[0] && !marksDone[0] && <div className="rounded" />}
                            <div className="text">Request Quote</div>
                        </div>
                        <div className="marks">
                            <img src={process.env.REACT_APP_IMAGES_PATH + "signMark.webp"} alt="signMark"/>
                            {marksView[1] && <div className="mdi-holder"></div>}
                            {marksDone[1] && <div className="mdi-holder"></div>}
                            {!marksView[1] && !marksDone[1] && <div className="rounded" />}
                            <div className="text">OTP Confirmation</div>
                        </div>
                        <div className="marks">
                            <img src={process.env.REACT_APP_IMAGES_PATH + "progress3.webp"} alt="progress-3" />
                            {marksView[2] && <div className="mdi-holder"></div>}
                            {marksDone[2] && <div className="mdi-holder"></div>}
                            {!marksView[2] && !marksDone[2] && <div className="rounded" />}
                            <div className="text">Quote Requested</div>
                        </div>
                        <div className="marks">
                            <img src={process.env.REACT_APP_IMAGES_PATH + "txMark.webp"} alt="txMark"/>
                            {marksView[3] && <div className="mdi-holder"></div>}
                            {marksDone[3] && <div className="mdi-holder"></div>}
                            {!marksView[3] && !marksDone[3] && <div className="rounded" />}
                            <div className="text">Quote Ready</div>
                        </div>
                        <div className="marks">
                            <img src={process.env.REACT_APP_IMAGES_PATH + "progress5.webp"} alt="progress-5"/>
                            {marksView[4] && <div className="mdi-holder"></div>}
                            {marksDone[4] && <div className="mdi-holder"></div>}
                            {!marksView[4] && !marksDone[4] && <div className="rounded" />}
                            <div className="text">Order Placed</div>
                        </div>
                        <div className="marks">
                            <img src={process.env.REACT_APP_IMAGES_PATH + "progress6.webp"} alt="progress-6"/>
                            {marksView[5] && <div className="mdi-holder"></div>}
                            {marksDone[5] && <div className="mdi-holder"></div>}
                            {!marksView[5] && !marksDone[5] && <div className="rounded" />}
                            <div className="text">Order Processed</div>
                        </div>

                    </div>
                    <div className="table-wrapper">
                        {(marksView[0]) && (
                            <LiquidationMldFirst
                                marksDone={marksDone}
                                setMarksDone={setMarksView}
                                showSecond={setShowSecond}
                                showButton={showSecond}
                                increaseUnits={increaseUnits}
                                decreaseUnits={decreaseUnits}
                                setUnitsFunc={setUnitsFunc}
                                units={units}
                                bondDetails={props?.bondDetails}
                                liquidationDetails={props?.liquidationDetails}
                                liquidationRedeem={liquidationRedeem}
                                setShowForth={setShowForth}
                                orderId={orderId}
                                loader={loader}
                                redemptionSuccess={props?.redemptionSuccess}
                            />
                        )}
                    </div>
                    {(showSecond || showForth) && (
                        <div className="text-center">
                            <OtpSection
                                userEmail={props?.userEmail}
                                phone={props?.phone}
                                verifyOtp={verifyOtp}
                                updateOtp={updateOtp}
                                bondDetails={props?.bondDetails}
                                otp={otp}
                                resendOtp={resendOtp}
                                showSecond={showSecond}
                                product={props.bondDetails.productType}
                            />
                        </div>
                    )}
                    {(showFinal || showSucess) && (
                        <LiquidationSucess
                            bondDetails={props?.bondDetails}
                            showSucess={showSucess}
                            product={props.bondDetails.productType}
                        />
                    )}
                </div>
            </div> : <Loader type="ball-clip-rotate" />}
        </>
    );
}
